var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "comp-con flex flex-row align-center justify-between" },
    [
      _c("div", { staticClass: "info-con flex flex-row align-center" }, [
        _c("img", {
          staticClass: "profile",
          attrs: { src: require("@/assets/list/profile.png"), alt: "profile" },
        }),
        _c("div", { staticClass: "info flex flex-col align-start" }, [
          _c("span", { staticClass: "name" }, [
            _vm._v(" " + _vm._s(_vm.name) + " "),
          ]),
          _c("span", { staticClass: "description text-ellipsis" }, [
            _vm._v(" " + _vm._s(_vm.description) + " "),
          ]),
        ]),
      ]),
      _c(
        "el-button",
        {
          attrs: { type: "primary", size: "small" },
          on: { click: _vm.enroll },
        },
        [_vm._v("挂号")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }